import type { FetchQueryOptions, QueryClient } from "@tanstack/react-query";

/**
 * Uma `queryOptions` qualquer.
 *
 * Os genéricos precisam ser `any` e não `unknown`: `FetchQueryOptions` é
 * contravariante no tipo do dado (o `staleTime` pode ser uma função que
 * RECEBE a query tipada), então a versão `unknown` não aceita nenhuma query
 * concreta. Como aqui a lista é heterogênea por natureza — cinco queries de
 * cinco formatos diferentes — e o valor nunca é lido, o tipo exato não tem o
 * que proteger.
 */
// biome-ignore lint/suspicious/noExplicitAny: ver o comentário acima
type WarmableQuery = FetchQueryOptions<any, any, any, any>;

/**
 * Dispara as requisições de uma tela SEM segurar a navegação.
 *
 * Chamado do `loader` da rota, ele roda no `preload` do TanStack Router —
 * que com `defaultPreload: "intent"` acontece no hover (desktop) e no
 * touchstart (celular), antes do clique terminar. Quando a tela finalmente
 * monta, a resposta já está no cache do React Query e o `useSuspenseQuery`
 * resolve sem suspender: o esqueleto simplesmente não aparece.
 *
 * `prefetchQuery` e não `ensureQueryData` de propósito: `ensureQueryData`
 * devolve uma promise que o router ESPERA, e aí um clique com cache frio
 * congela a tela anterior até a API responder — que é justamente o problema
 * que isto existe pra resolver. Aqui a navegação é sempre imediata; a
 * requisição só saiu na frente. `prefetchQuery` também engole o erro em vez
 * de rejeitar, então uma falha não vira unhandled rejection nem derruba a
 * navegação — quem trata é o `useQuery` da tela, como sempre.
 */
export function warmQueries(queryClient: QueryClient, queries: WarmableQuery[]) {
  for (const query of queries) void queryClient.prefetchQuery(query);
}
